/**
 * Created by admin on 2018/6/12.
 */
import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import MonthCalendar from '../../components/account/MonthCalendar';
import { Button, Checkbox, Modal, TimePicker } from 'antd';
import './WorkdayManage.less';
import moment from 'moment';
import { SEMICOLON } from '../../utils/constants';

const confirm = Modal.confirm;

const format = 'HH:mm';
const oneWeek = [1, 2, 3, 4, 5, 6, 7];
const months = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12'
];

class WorkdayManage extends PureComponent {
  constructor() {
    super();
    this.state = {
      startTime: '',
      endTime: '',
      weekList: [],
      showCalendar: false,
      theYear: 0,
      years: [],
      showSaveResult: ''
    };
  }

  componentDidMount() {
    // this.setState({theYear: moment().year()});
  }

  componentWillReceiveProps(props) {
    const { showSaveResult, selectYear, weekTime } = props;
    let startTime = '09:00';
    let endTime = '18:00';
    const theYear = moment().year();
    const years = [theYear, theYear + 1, theYear + 2];
    if (weekTime) {
      const s = weekTime.startTime.split(':');
      const e = weekTime.endTime.split(':');
      startTime = `${s[0]}:${s[1]}`;
      endTime = `${e[0]}:${e[1]}`;
      const weekList = weekTime.weeks ? weekTime.weeks.split(SEMICOLON) : [];
      this.setState({
        weekList,
        startTime,
        endTime,
        years,
        showSaveResult,
        theYear: selectYear
      });
    } else {
      this.setState({
        weekList: [],
        startTime,
        endTime,
        years,
        showSaveResult,
        theYear: selectYear
      });
    }
    if (this.state.showSaveResult) {
      const _this = this;
      setTimeout(function() {
        _this.setState({ showSaveResult: '' });
        _this.props.dispatch({
          type: 'account/update',
          payload: { showSaveResult: '' }
        });
      }, 3000);
    }
  }

  render() {
    const weekStr = [
      {
        key: 2,
        value: this.props.intl.formatMessage({ id: 'Monday' }),
        sub: 'M',
        iso: 1
      },
      {
        key: 3,
        value: this.props.intl.formatMessage({ id: 'Tuesday' }),
        sub: 'T',
        iso: 2
      },
      {
        key: 4,
        value: this.props.intl.formatMessage({ id: 'Wednesday' }),
        sub: 'W',
        iso: 3
      },
      {
        key: 5,
        value: this.props.intl.formatMessage({ id: 'Thursday' }),
        sub: 'T',
        iso: 4
      },
      {
        key: 6,
        value: this.props.intl.formatMessage({ id: 'Friday' }),
        sub: 'F',
        iso: 5
      },
      {
        key: 7,
        value: this.props.intl.formatMessage({ id: 'Saturday' }),
        sub: 'S',
        iso: 6
      },
      {
        key: 1,
        value: this.props.intl.formatMessage({ id: 'Sunday' }),
        sub: 'S',
        iso: 7
      }
    ];

    const { dispatch, holidays, intl } = this.props;
    const {
      startTime,
      endTime,
      weekList,
      showCalendar,
      theYear,
      years
    } = this.state;
    const hideMins = () => {
      const result = [];
      for (let i = 0; i < 60; i++) {
        result.push(i);
      }
      return result.filter(value => value % 5 !== 0);
    };

    return (
      <div className="workday-management">
        <div className="setting-row">
          <span className="row-label">
            <FormattedMessage id="work_day_label_select_year" /> :{' '}
          </span>
          <div className="row-content">
            <div className="year-select">
              {years.map(y => (
                <div
                  key={Math.random()}
                  className={`year${y == theYear ? ' this-year' : ''}`}
                  onClick={() => {
                    dispatch({ type: 'account/switchYear', year: y });
                  }}
                >
                  {y}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="setting-row">
          <span className="row-label">
            <FormattedMessage id="work_day_label_working_hours" /> :{' '}
          </span>
          <div className="row-content">
            <TimePicker
              inputReadOnly
              format={format}
              hideDisabledOptions
              disabledMinutes={hideMins}
              popupClassName="weekday-time-picker"
              value={moment(startTime, format)}
              onChange={(m, s) =>
                this.setState({ startTime: s === '' ? '09:00' : s })
              }
            />
            &nbsp;—&nbsp;&nbsp;
            <TimePicker
              inputReadOnly
              format={format}
              hideDisabledOptions
              disabledMinutes={hideMins}
              popupClassName="weekday-time-picker"
              value={moment(endTime, format)}
              onChange={(m, s) =>
                this.setState({ endTime: s === '' ? '18:00' : s })
              }
            />
          </div>
        </div>
        <div className="setting-row">
          <span className="row-label">
            <FormattedMessage id="work_day_label_working_day" /> :{' '}
          </span>
          <div className="row-content">
            <Checkbox.Group
              value={weekList}
              onChange={val => {
                this.setState({ weekList: val });
              }}
            >
              {weekStr.map(w => {
                return (
                  <Checkbox value={String(w.key)} key={w.key}>
                    <span>{w.value}</span>
                  </Checkbox>
                );
              })}
            </Checkbox.Group>
          </div>
        </div>
        <div className="setting-row">
          <span className="row-label" />
          <div className="row-content">
            <Button
              type="primary"
              onClick={e => {
                e.stopPropagation();
                if (weekList.length === 0) {
                  //一个都没选
                  Modal.error({ content: intl.formatMessage({id: 'work_day_working_day'}) });
                  return false;
                }
                if (
                  moment(startTime, format).isAfter(moment(endTime, format)) ||
                  moment(startTime, format).isSame(moment(endTime, format))
                ) {
                  Modal.error({
                    content: this.props.intl.formatMessage({
                      id: 'work_day_warning_work_hour'
                    })
                  });
                } else {
                  dispatch({
                    type: 'account/saveWeekTime',
                    payload: {
                      startTime: `${startTime}:00`,
                      endTime: `${endTime}:00`,
                      weeks: weekList.sort().join(SEMICOLON),
                      year: theYear
                    }
                  });
                }
              }}
            >
              <FormattedMessage id="work_day_btn_save" />
            </Button>
            {this.state.showSaveResult ? (
              <span className="save-message-tip">
                {this.state.showSaveResult}
              </span>
            ) : null}
          </div>
        </div>
        <div className="setting-row">
          <span className="row-label">
            <FormattedMessage id="work_day_label_Holiday" /> :{' '}
          </span>
          <div className="row-content">
            <span
              className="setting-link"
              onClick={() => {
                this.setState({ showCalendar: !showCalendar });
              }}
            >
              <FormattedMessage id="work_day_setting" />
              <div
                style={{ marginLeft: '10px' }}
                className={`setting-state ${showCalendar ? 's-on' : 's-off'}`}
              />
            </span>
          </div>
        </div>
        {showCalendar && (
          <div className="holiday-calendar">
            <div className="calendar-legend">
              <span className="workday-block" />
              <span className="legend-text">
                <FormattedMessage id="work_day_label_working_day" />
              </span>
              <span className="holiday-block" />
              <span className="legend-text">
                <FormattedMessage id="work_day_label_Holiday" />
              </span>
            </div>
            <div className="calendar-table">
              {months.map(m => (
                <MonthCalendar
                  key={Math.random()}
                  holidays={holidays}
                  weekStr={weekStr}
                  clickDay={d => {
                    const arr = d.split('-');
                    const { key, value } = weekStr.find(
                      w => w.iso === moment(d).isoWeekday()
                    );
                    const isHoliday = holidays.hasOwnProperty(d);
                    let h = isHoliday ? intl.formatMessage({id: 'Weekday'}) : intl.formatMessage({id: 'work_day_label_Holiday'});
                    confirm({
                      className: 'workday-setting-confirm',
                      title: intl.formatMessage({id: 'work_day_remind'},{date: d, value: value, holiday: h}),
                      onOk() {
                        dispatch({
                          type: 'account/clickSingleDay',
                          payload: { holidayTime: d, week: key, isHoliday }
                        });
                      }
                    });
                  }}
                  month={m}
                  year={theYear}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    account: { holidays, weekTime, showSaveResult, selectYear }
  } = state;
  return { holidays, weekTime, showSaveResult, selectYear };
};

export default connect(mapStateToProps)(injectIntl(WorkdayManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/WorkdayManage.js